import { useEffect, useState } from "react";
import { type ISO8601DateTime } from "../../types";
import { max } from "lodash";
import dayjs from "dayjs";

export const useCountdown = (targetDate: ISO8601DateTime) => {
  const countDownDate = dayjs(targetDate).toDate().getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownDate]);

  return {
    days: max([Math.floor(countDown / (1000 * 60 * 60 * 24)), 0]),
    hours: max([
      Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      0,
    ]),
    minutes: max([Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)), 0]),
    seconds: max([Math.floor((countDown % (1000 * 60)) / 1000), 0]),
  };
};
